/* import __COLOCATED_TEMPLATE__ from './unverified-data-export.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();